"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UNIVERSAL_SETTING_VALUE_TYPE = void 0;
exports.UNIVERSAL_SETTING_VALUE_TYPE = {
    STRING: 'STRING',
    NUMBER: 'NUMBER',
    NUMBER_ARRAY: 'NUMBER_ARRAY',
    STRING_ARRAY: 'STRING_ARRAY'
};
//# sourceMappingURL=universalSettingValueType.js.map